import { render } from "./TotalPointsCurrentYearRanking.vue?vue&type=template&id=b0845d7a"
import script from "./TotalPointsCurrentYearRanking.vue?vue&type=script&lang=js"
export * from "./TotalPointsCurrentYearRanking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__